
import attendance from "../../assets/images/att-mark.png";
import homework from "../../assets/images/hme-wrk-blue.png";
import fee from "../../assets/images/fee-img-blue.png";
import assignments from "../../assets/images/assign-blue.png";
import library from "../../assets/images/library-blue.png";
import timetable from "../../assets/images/time-table-blue.png";
import gallery from "../../assets/images/gallery-blue.png";
// import postmarks from "../../assets/images/post-marks-blue.png";
// import contact from "../../assets/images/contact-blue.png";
// import feedback from "../../assets/images/feedback-blue.png";
// import onlineexam from "../../assets/images/online-exam-blue.png";
// import sendmessage from "../../assets/images/send-msg.png";
// import Ellipse1604 from "../../assets/images/Ellipse 1604.png";
// import msg_line from "../../assets/images/msg_line.png";
// import home_icn from "../../assets/images/home_icn.png";
// import down_icn from "../../assets/images/down_icn.png";
// import messages_icn from "../../assets/images/messages_icn.png";
// import schoolbus from "../../assets/images/skool-bus-blue.png";
// import results from "../../assets/images/results-blue.png";

export const studentTabs = [
  {
    label: "Attendance",
    icon: attendance,
    route: "/student-attendance",
  },
  {
    label: "Home Work",
    icon: homework,
    route: "/student-home-works",
  },
  {
    label: "Fee",
    icon: fee,
    route: "/student-fee",
  },
  {
    label: "Assignments",
    icon: assignments,
    route: "/student-assignments",
  },
  {
    label: "Library",
    icon: library,
    route: "/library-books",
  },
  {
    label: "Time Table",
    icon: timetable,
    route: "/student-timetable",
  },
  {
    label: "Gallery",
    icon: gallery,
    route: "/student-gallery",
  },
];
